<template>
  <div class="step_box">
    <!-- 标题 -->
    <div class="step_title">串接三步驟</div>
    <!-- 内容 -->
    <div class="step_content_box">
      <div class="step_content01">
        <img src="../../../assets/img/home/icon_step_content01.png" alt="">
        <h3>提交資料</h3>
        <p>
          在線提交營業執照、身份證、銀行賬戶等基本信息，並按指引完成賬戶驗證
        </p>
      </div>
      <!-- 步骤图标 -->
      <p class="step_go">
        <img src="../../../assets/img/home/icon_step_go.png" alt="">
      </p>
      <!-- 内容 -->
      <div class="step_content02">
        <img src="../../../assets/img/home/icon_step_content02.png" alt="">
        <h3>簽署協議</h3>
        <p>
          微信支付團隊會在1-2個工作日內完成審核，審核通過後請在線簽約，即可體驗各項產品能力
        </p>
      </div>
      <!-- 步骤图标 -->
      <p class="step_go">
        <img src="../../../assets/img/home/icon_step_go.png" alt="">
      </p>
      <!-- 内容 -->
      <div class="step_content03">
        <img src="../../../assets/img/home/icon_step_content03.png" alt="">
        <h3>綁定場景</h3>
        <p>
          如需自行開發完成收款，需將商戶號與APPID進行綁定，或開通微信收款商業版（免開發）完成收款
        </p>
      </div>
    </div>
    <!-- 即刻申請! -->
    <div class="button" @click="register()">
      即刻申請!
    </div>
  </div>
</template>

<script>
export default {
  name: 'HomeStep',
  props: {
  },
  data() {
    return {
    }
  },
  methods: {
    register() {
      this.$router.push("/register");
    },
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .step_box {
    max-width: 1480px;
    margin: 0 auto;
  }
  /* 标题 */
  .step_title {
    font-size: 27px;
    color: #000000;
    text-align: center;
    font-weight: bold;
    margin-bottom: 68px;
  }
  /* 内容 */
  .step_content_box {
    display: flex;
    align-items: center;
    /* max-width: 1357px; */
    overflow-x: auto;
    margin: 0 auto;
  }
  .step_content_box > div {
    background: url("../../../assets/img/home/icon_step_back.png") no-repeat center;
    background-size: contain;
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    font-size: 17px;
    color: black;
  }
  .step_content_box .step_go {
    width: 72px;
    background: none;
    z-index: 10;
  }
  .step_content_box > div > img {
    padding-bottom: 24px;
  }
  .step_content_box > div > h3 {
    font-size: 25px;
    font-weight: bold;
  }
  .step_content_box > div > p {
    margin: 24px 0 64px 0;
    font-size: 11px;
    width: 200px;
    text-align: center;
    line-height: 25px;
    color: black;
  }
  .step_content_box .step_content01 {
    color: #f83d5c; 
  }
  .step_content_box .step_content02 {
    color: #fc9417; 
  }
  .step_content_box .step_content03 {
    color: #58bbf6; 
  }
  /* 即刻申請! */
  .button {
    width: 220px;
    margin: 0 auto;
    margin-top: 36px;
    margin-bottom: 42px;
    height: 62px;
    line-height: 62px;
    font-size: 15px;
    text-align: center;
    color: #d4d4d4;
    background: url("../../../assets/img/home/button_back.png") no-repeat center;
    background-size: contain;
    cursor:pointer;
  }



      /*  */
@media screen and (max-width:768px){
  /* 标题 */
  .step_content_box {
    margin: 0 4vw;
  }
  .step_content_box .step_go {
    margin: 0 30px;
  }
  .step_title {
    font-size: 8vw;
    margin: 7.2vw 0;
    font-weight: bold;
    color: black;
    text-align: center;
  }
  .button {
    margin: 10px auto;
    margin-bottom: 40px;
  }
}
</style>
